var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStrike = function SvgStrike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 13.75,
    stroke: "#fff",
    strokeWidth: 1.833
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.833,
    d: "m11.629 31.992 19.446-19.445"
  })));
};
export { SvgStrike as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIGZpbGw9Im5vbmUiPjxjaXJjbGUgY3g9IjIyIiBjeT0iMjIiIHI9IjEzLjc1IiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMS44MzMiLz48cGF0aCBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMS44MzMiIGQ9Im0xMS42MjkgMzEuOTkyIDE5LjQ0Ni0xOS40NDUiLz48L3N2Zz4=";